import core from "@/helpers/client";
const userViewPermissionService = {
  async updateUserViewPermission(applicationId, userId, viewId, body) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/users/${userId}/applications/${applicationId}/views/${viewId}/permissions?no-cache=1`,
      body
    );
    return result;
  },
  async deleteUserViewPermission(applicationId, userId, viewId) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/users/${userId}/applications/${applicationId}/views/${viewId}`
    );
    return result;
  },
};
export default userViewPermissionService;
